import { bold } from "colorette";

import packageJson from "@/package.json" with { type: "json" };
import { logger } from "@/src/utils/logger.ts";

export const showVersion = () => {
  const zeytalVersion = packageJson.version;
  logger.break();
  logger.success(bold(`Starting Zeytal v${zeytalVersion}`));
};
